import { normalize, schema } from 'normalizr'

const keyword = new schema.Entity('keywords')

const answer = new schema.Entity('answers', {
  keywords: [keyword],
})

export const question = new schema.Entity('questions', {
  answers: [answer],
})

const email = new schema.Entity('emails')

const signature = new schema.Entity('signatureActions')

const actionType = new schema.Entity('actionTypes', {
  action: {
    questions: [question],
    emails: [email],
    signatureActions: [signature],
  },
})

const goal = new schema.Entity('goals')

const condition = new schema.Entity('conditions')

const conditionSet = new schema.Entity('conditionSets', {
  conditions: [condition],
})

export const playbook = new schema.Entity('playbooks', {
  goals: [goal],
  actions: [actionType],
  targeting: {
    display: [conditionSet],
  },
})

const playbookList = [playbook]

export const playbookNormalizer = playbookResponse => normalize(playbookResponse, playbook)
export const playbookListNormalizer = playbookListResponse => normalize(playbookListResponse, playbookList)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/playbook/schema.js